import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class CustomIconsService {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  public initializeIcons() {
    this.matIconRegistry.addSvgIcon(
      'quiz-back',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/quiz-arrow-back.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'upload',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/upload.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'upload-white',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/upload-white.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'close',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/close-white.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'check',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/check.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'error',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/close.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'success-answer',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/success-answer.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'wrong-answer',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/wrong-answer.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'timer-end',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/timer-end.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'chevron-left',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/chevron-left.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'chevron-right',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/chevron-right.svg'),
    );

    // Trophy icons
    this.matIconRegistry.addSvgIcon(
      'trophy-gold',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/trophy-gold.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'trophy-silver',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/trophy-silver.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'trophy-bronze',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/trophy-bronze.svg'),
    );

    // Sharpshooter icons
    this.matIconRegistry.addSvgIcon(
      'sharpshooter-gold',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/sharpshooter-gold.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'sharpshooter-bronze',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../assets/icons/sharpshooter-bronze.svg',
      ),
    );

    // Trend icons
    this.matIconRegistry.addSvgIcon(
      'trend-up',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/trend-green.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'trend-down',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/trend-red.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'arrow-back',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../assets/icons/keyboard_arrow_down.svg',
      ),
    );

    this.matIconRegistry.addSvgIcon(
      'groups',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/groups_2.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'add',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/add.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'minus',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/minus.svg'),
    );

    // My-picks icons
    this.matIconRegistry.addSvgIcon(
      'success-point',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/success-point.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'total-point',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/total-point.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'win-point',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/win-point.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'fail-new',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/fail-new.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'success-new',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/success-new.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'lock',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/lock.svg'),
    );

    this.matIconRegistry.addSvgIcon(
      'info',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/info.svg'),
    );

    // Mini-countdown icons
    this.matIconRegistry.addSvgIcon(
      'timer',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/timer.svg'),
    );

    // Event-header icons
    this.matIconRegistry.addSvgIcon(
      'no-logo',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/images/no-logo.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'timer-countdown',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/timer-countdown.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-next',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/arrow-next.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-prev',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/arrow-prev.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'faq-circle',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/faq-circle-item.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'add',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/add.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'add-green',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/add-green.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'delete-green',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/delete-green.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'star',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/star.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-drop-down',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/arrow-drop-down.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'checked',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/checked.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'empty-page',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/empty-page.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'calendar',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/calendar.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'check-success',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/check-success.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'diagram',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/diagram.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'fire',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/fire.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'snapshot',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/snapshot.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'strong',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/strong.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'gold-medal',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/gold-medal.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'swipe',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/swipe.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'check-circle-unread',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/check_circle_unread.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'exclamation',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/priority-high-sz24.svg'),
    );
  }
}
